<template>
  <div class="container_account_box">
    <div class="account_info_title">
      <div class="title_h2">对公账号信息</div>
      <div class="account_info_tips">
        <i class="el-icon-warning-outline"></i>
        <span style="margin-left:5px;"
          >由贵公司开户行对合作公司账户进行充值,2~5分钟后进行手动刷新,即可显示充值金额</span
        >
      </div>
    </div>
    <el-tabs v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="当前合作公司" name="current">
        <template v-if="currentCompany">
          <div class="account_info_row" style="margin-top:15px;">
            <span class="account_info_label">承运主体:</span>
            <span class="account_info_value">{{
              currentCompany.branchName || "--"
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">服务费率(%):</span>
            <span class="account_info_value">{{
              currentCompany.taxPoint
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">企业名称:</span>
            <span class="account_info_value">{{
              currentCompany.companyName
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">开户银行:</span>
            <span class="account_info_value">{{
              currentCompany.openingBank
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">银行账号:</span>
            <span class="account_info_value">{{
              currentCompany.bankAccount
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">联行号:</span>
            <span class="account_info_value">{{
              currentCompany.subBankAccount
            }}</span>
          </div>
          <div class="balance-row">
            <!-- <span>账户余额(元):</span>
            <b class="highlight">{{ currentCompany.amount }}</b> -->
            <span>账户余额(元):</span>
            <b class="highlight">{{
              showAmount
                ? currentCompany.amount
                : "*".repeat(
                    currentCompany.amount
                      ? currentCompany.amount.toString().length
                      : 6
                  )
            }}</b>
            <img
              class="psw_icon"
              @click="showAmount = !showAmount"
              v-if="!showAmount"
              src="@/assets/icon/pswhidden.png"
              alt=""
            />
            <img
              class="psw_icon"
              @click="showAmount = !showAmount"
              v-else
              src="@/assets/icon/pswshow.png"
              alt=""
            />

            <div class="refresh_btn_box" @click="refreshBalance">
              <span class="refresh_btn_text">刷新金额</span>
              <i class="el-icon-refresh refresh_icon"></i>
            </div>
          </div>
        </template>
        <div class="no_company_box" v-if="!currentCompany">
          当前暂无合作的公司
        </div>
      </el-tab-pane>

      <el-tab-pane label="所有合作公司" name="all">
        <el-select
          v-if="companies.length"
          v-model="selectedCompany"
          placeholder="请选择公司"
        >
          <el-option
            v-for="company in companies"
            :key="company.branchCode"
            :label="company.branchName"
            :value="company.branchCode"
          ></el-option>
        </el-select>
        <template v-if="selectedObj">
          <div class="account_info_row" style="margin-top:15px;">
            <span class="account_info_label">承运主体:</span>
            <span class="account_info_value">{{
              selectedObj.branchName || "--"
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">服务费率(%):</span>
            <span class="account_info_value">{{ selectedObj.taxPoint }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">企业名称:</span>
            <span class="account_info_value">{{
              selectedObj.companyName
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">开户银行:</span>
            <span class="account_info_value">{{
              selectedObj.openingBank
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">银行账号:</span>
            <span class="account_info_value">{{
              selectedObj.bankAccount
            }}</span>
          </div>
          <div class="account_info_row">
            <span class="account_info_label">联行号:</span>
            <span class="account_info_value">{{
              selectedObj.subBankAccount
            }}</span>
          </div>

          <div class="balance-row">
            <span>账户余额(元):</span>
            <b class="highlight">{{ selectedObj.amount }}</b>
            <div class="refresh_btn_box" @click="refreshBalance">
              <span class="refresh_btn_text">刷新金额</span>
              <i class="el-icon-refresh refresh_icon"></i>
            </div>
            <!-- <el-button
            :loading="loaingAmount"
            type="primary"
            @click="refreshBalance"
            >刷新金额</el-button
          > -->
          </div>
        </template>
        <div class="no_company_box" v-if="!companies.length">
          当前暂无合作的公司
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 交易记录区域 -->
    <!-- 记录类型选项卡 -->
    <div class="record-carousel-container">
      <!-- 顶部切换按钮 -->
      <div class="record-type-buttons">
        <el-button-group>
          <el-button
            :type="recordType === 'all' ? 'primary' : 'default'"
            @click="setRecordType('all')"
            >交易记录</el-button
          >
          <el-button
            :type="recordType === 'recharge' ? 'primary' : 'default'"
            @click="setRecordType('recharge')"
            >充值记录</el-button
          >
          <!-- <el-button
            :type="recordType === 'withdraw' ? 'primary' : 'default'"
            @click="setRecordType('withdraw')"
            >提现记录</el-button
          > -->
        </el-button-group>
      </div>
      <!-- 轮播组件 -->
      <el-carousel
        :autoplay="false"
        indicator-position="none"
        arrow="never"
        ref="recordCarousel"
        :initial-index="carouselIndex"
      >
        <el-carousel-item class="item_height" name="all">
          <accountRecord
            recordType="all"
            :partyCode="partyCode"
            v-if="recordType === 'all'"
          ></accountRecord>
        </el-carousel-item>
        <el-carousel-item class="item_height" name="recharge">
          <accountRecord
            recordType="recharge"
            :partyCode="partyCode"
            v-if="recordType === 'recharge'"
          ></accountRecord>
        </el-carousel-item>
        <!-- <el-carousel-item class="item_height" name="withdraw">
          <accountRecord
            recordType="withdraw"
            v-if="recordType === 'withdraw'"
          ></accountRecord>
        </el-carousel-item> -->
      </el-carousel>
    </div>
  </div>
</template>

<script>
import {} from "@/api/shipment";
import { currentPartnerCompany } from "@/api/invoice";
import accountRecord from "@/views/basicInfo/shipment/shipmentAccount/components/accountRecord.vue";
export default {
  name: "companyList",
  components: {
    accountRecord
  },
  data() {
    return {
      showAmount: false,
      loaingAmount: false,
      // demo
      activeTab: "current",
      recordType: "all",
      currentPage: 1,
      pageSize: 10,
      showFullAccount: false,

      // 账户数据
      currentCompany: null,

      // 所有合作公司
      companies: [],

      selectedCompany: null
    };
  },

  computed: {
    selectedObj() {
      return this.companies.find(
        item => item.branchCode === this.selectedCompany
      );
    },
    // 计算掩码后的账号
    maskedAccount() {
      const acc = this.currentCompany.account;
      return (
        acc.substring(0, 4) + " **** **** " + acc.substring(acc.length - 8)
      );
    },

    // 根据类型过滤记录
    filteredRecords() {
      let result = this.records;

      if (this.recordType === "recharge") {
        result = result.filter(item => item.amount > 0);
      } else if (this.recordType === "withdraw") {
        result = result.filter(item => item.amount < 0);
      }

      // 分页处理
      const start = (this.currentPage - 1) * this.pageSize;
      return result.slice(start, start + this.pageSize);
    },

    // 根据recordType计算轮播索引
    carouselIndex() {
      const typeMap = {
        all: 0,
        recharge: 1,
        withdraw: 2
      };
      return typeMap[this.recordType] || 0;
    },
    partyCode() {
      return this.$store.state.user.code;
    }
  },

  created() {
    this.getCurrentPartnerCompany();
  },

  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async getCurrentPartnerCompany() {
      try {
        let data = {
          partyCode: this.partyCode
        };
        let res = await currentPartnerCompany(data);
        if (res.status === 0) {
          // 所有合作公司
          this.companies = res.data.list;
          this.companies = this.companies.filter(
            item => item.mainAccountFlag === 1
          );
          if (this.companies.length) {
            this.selectedCompany = this.companies[0].branchCode;
          }
          console.log("this.companies======", this.companies);
          //当前合作公司
          if (res.data && Object.keys(res.data.partnerCompany).length) {
            this.currentCompany = res.data.partnerCompany || null;
          }
          console.log("this.currentCompany======", this.currentCompany);
        }
        console.log("res=======", res);
      } catch (err) {}
    },
    // 标签切换处理
    handleTabChange(tab) {
      console.log("切换到标签:", tab.name);
    },

    // 设置记录类型并切换轮播
    setRecordType(type) {
      this.recordType = type;
      // 使用$nextTick确保DOM更新后再操作轮播组件
      this.$nextTick(() => {
        if (this.$refs.recordCarousel) {
          this.$refs.recordCarousel.setActiveItem(this.carouselIndex);
        }
      });
    },

    // 刷新余额
    refreshBalance() {
      this.loaingAmount = true;
      checkbalance({ partCode: this.partyCode })
        .then(response => {
          this.loaingAmount = false;
          this.$message({
            message: "账户余额：" + response.data.amount,
            type: "success"
          });
          this.currentCompany.amount = response.data.amount;
        })
        .catch(call => {
          this.loaingAmount = false;
          this.$message.error("网络异常，请重试");
        });
    },

    // 充值操作
    recharge() {
      this.$message.info("打开充值界面");
      // 实际充值逻辑
    },

    // 提现操作
    withdraw() {
      this.$message.warning("提现功能开发中");
    },

    // 查看回单
    viewReceipt(record) {
      this.$alert(`显示 ${record.waybill} 的回单详情`, "电子回单", {
        confirmButtonText: "确定",
        callback: action => {}
      });
    },

    // 分页处理
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
    },

    handleCurrentChange(page) {
      this.currentPage = page;
    }
  }
};
</script>

<style scoped lang="scss">
.item_height {
  height: 720px;
}
.account_info_title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  flex-wrap: wrap;

  .title_h2 {
    font-size: 20px;
    font-weight: bold;
    margin-right: 20px;
  }
}
.back-button {
  width: 79px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #409eff;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
  margin-left: -20px;
  margin-top: -20px;
  &:hover {
    background-color: #ecf5ff;
  }

  i {
    margin-right: 5px;
    font-size: 14px;
  }
}
.account_info_tips {
  color: #a3a3a3;
  flex: 1;
  display: flex;
  align-items: center;
}

.account_info_row {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  border-bottom: 1px dashed #ebeef5;
}

.account_info_label {
  width: 100px;
  color: #606266;
  font-weight: 600;
  margin-right: 15px;
  text-align: right;
  font-size: 15px;
}

.account_info_value {
  color: #303133;
  font-size: 15px;
  flex: 1;
}

.container_account_box {
  padding: 30px;
}
.container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 15px;
}

.account-card,
.record-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.company-header {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #2a6efd;
}

.balance-row {
  margin-top: 20px;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.balance-row > span {
  margin-right: 10px;
}

.highlight {
  font-size: 18px;
  color: #f56c6c;
  margin-right: 20px;
}

.bank-account {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.bank-account i {
  margin-left: 8px;
  color: #2a6efd;
}

.refresh_btn_box {
  display: flex;
  align-items: center;
}

.refresh_btn_text {
  margin-right: 3px;
  color: #2a6efd;
}
.refresh_icon {
  color: #2a6efd;
}

.help-tips {
  margin-top: 30px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}

.help-tips p {
  margin: 5px 0;
}

/* 轮播相关样式 */
.record-carousel-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 180px;
}

.record-type-buttons {
  padding: 15px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  display: flex;
  // justify-content: center;
}

.el-carousel {
  height: 720px;
  // border: 2px solid red;
}

.el-carousel__item {
  padding: 20px;
  // overflow-y: auto;
}

/* 确保轮播项内容不会溢出 */
.el-carousel__container {
  height: 100%;
}
.no_company_box {
  margin-top: 30px;
  margin-bottom: 190px;
}
.psw_icon {
  width: 20px;
  height: 20px;
  margin-right: 30px;
  cursor: pointer;
}
</style>
